import { graphql } from "../gql";

export const preflightReportTransferQueryDoc = graphql(`
  query preflightReportTransfer($input: PreflightReportTransferInput!) {
    preflightReportTransfer(input: $input) {
      __typename
      reportTypes
      transferableClaims {
        id
        icn
      }
      clientDestinations {
        displayName
        method
        id
      }
      summary {
        description
        key
        name
        value
      }
      namingConventions {
        displayName
        namingConvention
      }
    }
  }
`);
